import { Box } from "@mui/material";
import { LicenseOptionImage } from "Components/Licenses/LicenseOptionImage";
import { PendingLicenseDisplay } from "Components/Licenses/PendingLicenseDisplay";
import { LICENSE_CODE_TO_DATA_MAP } from "Components/Licenses/licenseUtils";
import { Dropdown } from "Components/Shared/Inputs/Dropdown";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const PAGE_RESOURCES = Resources.Hunter.LicensePaymentPending;

const buildLicenseOptions = (licenses: Array<PartyLicenseDto>) => {
  const baseNames = licenses.map(
    ({ code, region }) => `${LICENSE_CODE_TO_DATA_MAP[code].title} (${region})`,
  );

  return licenses.map((license, index) => {
    const name = baseNames[index];
    const isDuplicateName =
      baseNames.filter((baseName) => baseName === name).length > 1;
    const occurrenceNo = baseNames
      .slice(0, index + 1)
      .filter((baseName) => baseName === name).length;

    return {
      Value: license.publicID,
      Name: isDuplicateName ? `${name} #${occurrenceNo}` : name,
      Icon: <LicenseOptionImage license={license} />,
    };
  });
};

type Props = {
  licenses: Array<PartyLicenseDto>;
  selectedLicense?: PartyLicenseDto;
  onSelect: (licensePublicID: string) => void;
};

// Which pending order is being worked with: a dropdown when there are several,
// a read-only display of the single one otherwise.
export const PendingLicenseSelector = ({
  licenses,
  selectedLicense,
  onSelect,
}: Props) => {
  const { t } = useResource();

  if (licenses.length > 1) {
    return (
      <Box width="100%" textAlign="left">
        <Dropdown
          name="pending-license"
          label={t(PAGE_RESOURCES.SelectedLicenseLabel)}
          options={buildLicenseOptions(licenses)}
          value={selectedLicense?.publicID}
          onChange={onSelect}
        />
      </Box>
    );
  }

  if (!selectedLicense) {
    return null;
  }

  return (
    <PendingLicenseDisplay
      license={selectedLicense}
      label={t(PAGE_RESOURCES.SelectedLicenseLabel)}
    />
  );
};
